import { useMemo } from "react";
import { defineMessages, useIntl } from "react-intl";
import { IconMessageCircleQuestion } from "@tabler/icons-react";
import { useLocaleFormatter } from "@ct-react/locale";
import { AnnualPrice, BasicPrice, SeasonalPrice } from "@shared/graphql";
import { ArticleType } from "@shared/url";
import { pricing } from "../../../i18n/sharable-defs";
import { Wrapper } from "../../layout/wrapper";
import ContactForm from "../../contact-form";
import "./any-contacting.scss";

const transDefs = defineMessages({
  title: { id: "article.on-interest.contact.title", defaultMessage: "Entrez en contact" },
  resume: { id: "article.on-interest.contact.resume", defaultMessage: "Intéressé ? {txt}." }
});

type MainProps = {
  articleId: string;
  type: ArticleType;
  price: BasicPrice | SeasonalPrice | AnnualPrice;
};

type MobileResumeProps = Pick<MainProps, "type" | "price">;
type ContentProps = Pick<MainProps, "articleId">;

const MobileResume = ({ type, price }: MobileResumeProps) => {

  const intl = useIntl();
  const { print } = useLocaleFormatter();

  const formattedPrice = useMemo(() => {
    if (!price || price.onDemand) return intl.formatMessage(pricing.onDemand);
    const format = print.price(price.value);
    switch (type) {
      case ArticleType.SEASONAL:
        const seasonal = price as SeasonalPrice;
        return seasonal.isMonthly
          ? intl.formatMessage(pricing.byMonth, { price: format })
          : format;
      case ArticleType.ANNUAL:
        return intl.formatMessage(pricing.byMonth, { price: format });
      default:
        return format;
    }
  }, [ type, price, intl ]);

  return (
    <>
      <IconMessageCircleQuestion className="m-icon" />
      <div className="full-resume">
        <span className="amount">{formattedPrice}</span>
        {intl.formatMessage(transDefs.resume, { txt: intl.formatMessage(transDefs.title) })}
      </div>
    </>);

}

const Content = ({ articleId }: ContentProps) => {

  const intl = useIntl();

  return (
    <>
      <h2>{intl.formatMessage(transDefs.title)}</h2>
      <ContactForm related={{ articleId }} />
    </>);

}

const AnyContactingBox = (props: MainProps) => (
  <Wrapper.StickableBox className="contact-wrapper"
                        resume={<MobileResume {...props} />}
                        content={<Content articleId={props.articleId} />} />);

export default AnyContactingBox;
